module.exports = "/static/assets/46b3bcec4c8ee66207e35ad0d92b343c.png";